<template>
  <div class="login-view">
    <h5 class="center-align indigo-text m-b">Pour accèder à l'application de vente, vous devez vous connecter</h5>

    <div class="form col m6 offset-m3 s12 z-depth-1 grey lighten-4">
      <div class="row">
        <div class="col s12"></div>
      </div>
      <div class="row">
        <div class="input-field col s12">
          <input
            type="text"
            id="username"
            v-model="username"
            required="required"
            autofocus="autofocus"
          >
          <label for="username">Entrez le nom d'utilisateur</label>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12">
          <input type="password" id="password" v-model="password" required="required" @keyup.enter="submitLogin">
          <label for="password">Entrez le mot de passe</label>
        </div>
      </div>

      <p v-if="loginError" class="center-align red-text">Erreur d'authentification. Veuillez réessayer.</p>

      <div class="row">
        <div class="col s12 center-align">
          <button type="submit" @click="submitLogin" class="btn btn-large waves-effect indigo">Connexion</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: "login-view",
  data() {
    return {
      username: "",
      password: "",
      loginError: false
    };
  },
  methods: {
    submitLogin() {
      this.loginError = false;
      axios
        .post(process.env.VUE_APP_VENTE_URL + "/auth/login", {
          username: this.username,
          password: this.password
        })
        .then(response => {
          // login user, store username & store the token and redirect to index
          this.$store.commit("loginUser", response.data.user.name);
          localStorage.setItem("token", response.data.access_token);
          this.$router.push('/');
        })
        .catch(error => {
          this.loginError = true;
        });
    }
  }
};
</script>

<style scoped>
.form {
  padding: 32px 48px 0px;
  border: 1px solid rgb(238, 238, 238);
}
</style>
